import {http} from './http/request';
import {loadLibraryTags} from './library-tags';
import defaultSpriteTags from './libraries/sprite-tags';

const SCRATCH_SPRITE_PAGE_SIZE = 30;
const SPRITE_TAG_DICT_CODE = 'scratch_sprite_tag';

const normalizeTags = tags => {
    if (Array.isArray(tags)) return tags;
    return String(tags || '')
        .split(',')
        .map(tag => tag.trim())
        .filter(tag => tag);
};

const normalizeResource = item => {
    if (!item || typeof item !== 'object') {
        return null;
    }
    const dataFormat = item.dataFormat || '';
    const md5ext = item.md5ext || (item.assetId && dataFormat ? `${item.assetId}.${dataFormat}` : '');
    return {
        ...item,
        tags: normalizeTags(item.tags),
        dataFormat,
        md5ext
    };
};

const normalizeResources = items => (
    (Array.isArray(items) ? items : [])
        .map(normalizeResource)
        .filter(item => item && item.assetId && item.dataFormat && item.name)
);

const normalizeSprite = item => {
    const sprite = item || {};
    return {
        ...sprite,
        tags: normalizeTags(sprite.tags),
        isStage: false,
        variables: sprite.variables || {},
        costumes: normalizeResources(sprite.costumes),
        sounds: normalizeResources(sprite.sounds),
        blocks: sprite.blocks || {}
    };
};

const buildScratchSpriteParams = query => {
    const params = {
        pageIndex: query.pageIndex || 1,
        pageSize: query.pageSize || SCRATCH_SPRITE_PAGE_SIZE,
        isStage: false
    };
    const filterQuery = (query.filterQuery || '').trim();
    const selectedTag = query.selectedTag || 'all';
    if (filterQuery) {
        params.name = filterQuery;
    }
    if (selectedTag !== 'all') {
        params.tags = selectedTag;
    }
    return params;
};

const loadScratchSpriteTags = () =>
    loadLibraryTags(SPRITE_TAG_DICT_CODE, defaultSpriteTags);

const loadScratchSprites = query => {
    const endpoint = query.sourceScope === 'mine' ?
        '/scratchSprite/myPageList' :
        '/scratchSprite/pageList';
    return http.get(endpoint, buildScratchSpriteParams(query))
        .then(response => {
            if (response && response.success === false) {
                throw new Error(response.message || 'Sprite library load failed');
            }
            const result = response.result || {};
            const pageIndex = query.pageIndex || 1;
            const pageSize = query.pageSize || SCRATCH_SPRITE_PAGE_SIZE;
            const records = (result.records || [])
                .map(normalizeSprite)
                .filter(sprite => sprite.name && sprite.costumes.length > 0);
            const pages = Number(result.pages);
            const total = Number(result.total);
            const hasMore = pages ?
                pageIndex < pages :
                (total ? pageIndex * pageSize < total : records.length >= pageSize);

            return {
                hasMore,
                records,
                response
            };
        });
};

const loadRandomScratchSprite = () => (
    http.get('/scratchSprite/random')
        .then(response => {
            if (response && response.success === false) {
                throw new Error(response.message || 'Sprite random load failed');
            }
            if (!response || !response.result) {
                throw new Error('Sprite random load failed');
            }
            const sprite = normalizeSprite(response.result);
            if (!sprite.name || sprite.costumes.length === 0) {
                throw new Error('Sprite random load failed');
            }
            return sprite;
        })
);

export {
    SCRATCH_SPRITE_PAGE_SIZE,
    SPRITE_TAG_DICT_CODE,
    loadRandomScratchSprite,
    loadScratchSpriteTags,
    loadScratchSprites
};
